import * as React from "react";
import { useHistory } from "react-router-dom";

import Layout from "../shared/Layout";
import Hero from "../shared/Hero";

const SuccessScreen: React.FC = () => {
  const history = useHistory();
  React.useEffect(() => {
    const timer = setTimeout(() => {
      history.replace("/");
    }, 4000);
    return () => clearTimeout(timer);
  }, [history]);
  return (
    <Layout>
      <Hero role="SUCSSES" />
      <div className="flex flex-col flex-1 items-center justify-center mx-5 overflow-hidden h-full">
        <div >
          <h1 className="text-4xl  text-center">
             Good luck!
          </h1>
          <h1 className="text text-center pt-8 pb-4">
            Look out for your results <br />on the screen above
          </h1>
        </div>
      </div>
    </Layout>
  );
};

export default SuccessScreen;
